import React from 'react';
import { graphql, compose } from 'react-apollo';
import { findOneOrCreateUser } from '../../graphqlDic';
import { connect } from 'react-redux';
import jwtDecode from 'jwt-decode';

import { loggedInUser } from './../../actions/user';
import User from './User';
import Search from '../Search/Search';
import { Link, Route } from 'react-router-dom';
import { menus } from '../../menus';
import { BASE_URL } from '../../constants/Common';
import { withRouter } from 'react-router-dom';
import { callGetCoinInfo } from './../../helpers/ApiPayment';

const MenuLink = ({ label, to, activeOnlyWhenExact }) => {
    return (
        <Route
            path={to}
            exact={activeOnlyWhenExact}
            children={({ match }) => {
                let active = match ? 'active' : '';
                return (
                    <li className={active}>
                        <Link to={to}>
                            {label}
                        </Link>
                    </li>
                );
            }}
        />
    );
}

class Header extends React.Component {

    constructor(props) {
        super(props);
        const token = localStorage.getItem('token');
        if (!!token) {
            const loggedInUser = jwtDecode(token);
            const { name, fullname, email, mobile, avatar, uniqid, id, birthday, address, is_vip } = loggedInUser;
            const data = {
                name,
                fullname,
                email,
                phone: mobile,
                avatar,
                uniqid,
                vietid: id,
                birthday,
                address,
                is_vip,
                status: '1'
            }
            this.props.mutate({
                variables: { userInput: data }
            })
                .then(({ data }) => {
                    if (data.findOneOrCreateUser) {
                        const user = data.findOneOrCreateUser;

                        // refetch scoin
                        callGetCoinInfo({ email: user.email })
                            .then(user => {
                                return user.users;
                            }).then(data => {
                                let scoin = 0;
                                for (let index in data) {
                                    scoin = data[index].scoin;
                                }
                                user.scoin = scoin;
                                this.props.loggedInUser(user);
                            }).catch(console.log)
                    }

                })
                .catch(({ errors }) => {
                    console.log('Error: ', errors);
                })
        }
    }

    showMenus = menus => {
        let result = [];
        if (menus.length) {
            result = menus.map((menu, index) => {
                return (
                    <MenuLink
                        key={index}
                        to={menu.to}
                        label={menu.name}
                        activeOnlyWhenExact={menu.exact}
                    />
                );
            });
        }
        return result;
    }

    render() {
        let { user_info } = this.props;

        let data = [];
        let history_location = JSON.parse(sessionStorage.getItem('history_location'));

        if (this.props.location.pathname !== '/login') {
            data = history_location ? [...history_location, this.props.location.pathname] : [this.props.location.pathname];
            sessionStorage.setItem('history_location', JSON.stringify(data));
        }

        return (
            <div>
                <div className="header">
                    <nav className="navbar navbar-default">
                        <div className="container-fluid">
                            {/* Brand and toggle get grouped for better mobile display */}
                            <div className="navbar-header">
                                <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
                                    <span className="sr-only">Toggle navigation</span>
                                    <span className="icon-bar" />
                                    <span className="icon-bar" />
                                    <span className="icon-bar" />
                                </button>
                                <Link to="/" className="navbar-brand">
                                    <img src={BASE_URL + 'images/logo.png'} alt="logo" />
                                    <span className="sr-only">PegaTV</span>
                                </Link>
                            </div>
                            {/* Collect the nav links, forms, and other content for toggling */}
                            <div className="collapse navbar-collapse" id="bs-example-navbar-collapse-1">
                                <ul className="nav navbar-nav navbar-main">
                                    {this.showMenus(menus)}
                                </ul>
                                <ul className="nav navbar-nav navbar-right">
                                    <Search />
                                    <User />
                                </ul>
                            </div>
                            {/* /.navbar-collapse */}
                        </div>
                        {/* /.container-fluid */}
                    </nav>
                </div>
                {!user_info.is_vip ? <div className="sub-header">
                    <div className="container">
                        <div className="clearfix">
                            <div className="pull-right">
                                <Link to={"/account-vip"}>
                                    <img src={BASE_URL + 'images/vip.png'} alt="vip" />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div> : null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user_info: state.root.users
    }
}

export default compose(
    graphql(findOneOrCreateUser)
)(withRouter(
    connect(mapStateToProps, { loggedInUser })(Header)
));



// WEBPACK FOOTER //
// ./src/components/MainPanel/Header.js